<div class="form-group">
    <label class="ui-checkbox input-label">
    <input type="checkbox"
           name="fieldOptions.totalvisibleinfooter" value="{{fieldOptions.totalvisibleinfooter}}"
           [(ngModel)]="fieldOptions.totalvisibleinfooter"
           (ngModelChange)="dataChangedEvent($event)" class="form-control">
    <span><b>Calculate total in Grid footer</b></span>
  </label>
</div>